import { useEffect, useState, Suspense } from 'react';
import { Outlet, useRouter } from '@tanstack/react-router';
import { TanStackRouterDevtoolsInProd } from '@tanstack/react-router-devtools';

declare global {
	interface Window {
		onbeforeinstallprompt?: unknown;
		toggleRouterDevtools?: () => void;
	}
}

export function RootRouteComponent() {
	const [showDevtools, setShowDevtools] = useState(
		import.meta.env.MODE === 'development',
	);
	useEffect(() => {
		window.toggleRouterDevtools = () => setShowDevtools(old => !old);
	}, []);
	return (
		<>
			<Outlet />
			{showDevtools && (
				<Suspense fallback={null}>
					<TanStackRouterDevtoolsInProd position="bottom-left" />
				</Suspense>
			)}
		</>
	);
}

export function NotFound() {
	const { navigate } = useRouter();

	useEffect(() => {
		navigate({ to: '/' }); // Redirect to homepage
	}, [navigate]);

	return null;
}
